import { render, staticRenderFns } from "./guide_install.vue?vue&type=template&id=7956b472&scoped=true"
import script from "./guide_install.vue?vue&type=script&lang=js"
export * from "./guide_install.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7956b472",
  null
  
)

export default component.exports